import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './artifact.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { API_PREFIX } from './artifact.api';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';
import { DURABILITIES, EQUIPMENT_RARITY, ORIGIN } from '~/config/constants';

ArtifactForm.defaultProps = {
    pictureAttributeNames: null,
};
ArtifactForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function ArtifactForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const { actions, powers, upgrades, characterClasses } = cardMetaData;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(artifactMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values } = props;

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                sm="3"
                                                name="name"
                                                className="d-flex flex-column justify-content-end"
                                            />
                                            {pictureAttributeNames.map((imgName, i) => (
                                                <Col
                                                    key={i}
                                                    sm={3}
                                                >
                                                    <FileUploadedWithResetCount
                                                        pictureName={imgName}
                                                        pictureVal={values[imgName]}
                                                        resetCount={resetCount}
                                                        id={imgName}
                                                    />
                                                </Col>
                                            ))}
                                        </Form.Row>
                                        
                                        <Form.Row className="d-flex justify-content-between">
                                            <TextArea
                                                name={'description'}
                                                sm={3}
                                                rows={4}
                                            />
                                            <FormSelect
                                                name="rarity"
                                                options={EQUIPMENT_RARITY}
                                                sm={3}
                                                label="Rarity"
                                            />
                                            <Selectize
                                                name="origin"
                                                options={ORIGIN}
                                                sm={3}
                                                label="Origin"
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                sm="3"
                                                name="season"
                                            />
                                            <Selectize
                                                name="equipable_to"
                                                options={characterClasses}
                                                sm={3}
                                                label="Equipable To"
                                            />
                                        </Form.Row>

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default ArtifactForm;
